import { StackProps, Stack } from '@mui/material';

type Props = StackProps;

export function BottomBar({ children, sx, ...props }: Props) {
  return (
    <Stack
      gap="10px"
      {...props}
      direction="row"
      sx={{
        position: 'sticky',
        bottom: 0,
        width: '100%',
        backgroundColor: '#ffffff',
        padding: '12px',
        borderTop: '1px solid #D0D5DD',
        zIndex: 10,
        ...sx,
      }}
    >
      {children}
    </Stack>
  );
}
